export class EmailVM {
    email:string;
}
